import { getTransform } from "./qaConfig"

const getContent_CRUD_Config = {
  ...getTransform("dk_content_product_category_create_name_input"),
  ...getTransform("dk_content_product_category_create_name_error"),

  ...getTransform("dk_content_product_category_create_gl_code_input"),
  ...getTransform("dk_content_product_category_create_gl_code_error"),

  ...getTransform("dk_content_product_category_create_status_enabled_input"),
  ...getTransform("dk_content_product_category_create_status_disabled_input"),

  ...getTransform("dk_content_product_category_create_make_it_Default_input"),

  ...getTransform("dk_content_product_category_dailog_create_save_button"),
  ...getTransform("dk_content_product_category_dailog_create_close_button"),

  ...getTransform("dk_content_product_category_delete_icon"),
}



export {
  getContent_CRUD_Config,
}